import React, { Fragment } from 'react';
import { Form, Input, DatePicker } from 'antd';
import {
  dateFormat,
  start_date,
} from '../../../../../../common/utils/configFormField';
import locale from 'antd/lib/date-picker/locale/ru_RU';

const Kasko = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Полис КАСКО:</span>
      <Form.Item>
        {getFieldDecorator('kaskoNum')(
          <Input
            maxLength={20}
            placeholder="Укажите серию и номер полиса КАСКО (при наличии)"
            disabled={disabled}
          />
        )}
      </Form.Item>
      <div className="kackoArea">
        <span className="label">Действителен до:</span>
        <Form.Item>
          {getFieldDecorator('kaskoValidUntilDate')(
            <DatePicker
              placeholder="ДД.ММ.ГГГГ"
              format={dateFormat}
              disabledDate={start_date}
              className="basicInput"
              disabled={disabled}
              locale={locale}
            />
          )}
        </Form.Item>
      </div>
    </Fragment>
  );
};

export default Kasko;
